import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { Dialog, Box, OutlinedInput, Typography, Stack } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import notifier from "../Notifier";
import {
  checkExtension,
  getErrorString,
  isEmpty,
} from "../../constants/function";
import ApiService from "../../services/api-service";
import { Upload } from "react-iconly";
import Loader from "../Loader";
import { capitalize } from "lodash";
import ConfirmPlayListNft from "../ConfirmPlaylistNft";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AddCollaboratorPopup(props) {
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [loading, setLoading] = useState(false);

  const save = async () => {
    const payload = {
      email: props["email"],
      firstName: firstName,
      lastName: lastName,
    };
    try {
      setLoading(true);
      const response = props.isRoyalty
        ? await ApiService.INVITE_ROYALTIES(payload)
        : await ApiService.INVITE_COLLABORATOR(payload);
      setLoading(false);
      payload["_id"] = response["result"]._id;
      props.handleClose(payload, false);
    } catch (error) {
      notifier.error(getErrorString(error));
      setLoading(false);
    }
  };
  useEffect(() => {
    return () => {
      setFirstName("");
      setLastName("");
    };
  }, []);
  return (
    <div>
      <Dialog
        onBackdropClick={() => props.handleClose(null, true)}
        open={props.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => props.handleClose(null, false)}
        PaperProps={{
          style: {
            backgroundColor: "#1E1E1E",
            boxShadow: "none",
            color: "#000000",
            borderRadius: 16,

            margin: "0",
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <Stack spacing={1}>
          <Stack sx={{ padding: "16px" }} spacing={1}>
            <Stack spacing={1}>
              <Typography className="fs-17 fw-b">
                Add Collaborators detail
              </Typography>
              <DialogContent sx={{ padding: 0 }}>
                <Stack spacing={1}>
                  <OutlinedInput
                    sx={{
                      width: "100%",
                      backgroundColor: "#262626",
                      height: "50px",
                    }}
                    autoFocus
                    margin="dense"
                    id="firstName"
                    placeholder={`Enter first ${capitalize(props.api)} name`}
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                  <OutlinedInput
                    sx={{
                      width: "100%",
                      backgroundColor: "#262626",
                      height: "50px",
                    }}
                    autoFocus
                    margin="dense"
                    id="lastName"
                    placeholder={`Enter last ${capitalize(props.api)} name`}
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </Stack>
              </DialogContent>
            </Stack>

            <DialogActions sx={{ justifyContent: "space-between" }}>
              <Button
                sx={{ maxWidth: "150px", padding: "10px 35px" }}
                color="default"
                onClick={() => props.handleClose(null, false)}
              >
                Cancel
              </Button>
              <Button
                sx={{ maxWidth: "150px", padding: "10px 35px" }}
                variant="contained"
                color="primary"
                onClick={save}
                disabled={!firstName}
              >
                Invite
              </Button>
            </DialogActions>
          </Stack>
        </Stack>
        {loading ? <Loader /> : null}
      </Dialog>
    </div>
  );
}
